import { Typography } from '@mui/material';
import React, { FC } from 'react';
import OnboardingDialog from './OnboardingDialog';

export const OnboardingError: FC<
  React.PropsWithChildren<OnboardingErrorProps>
> = ({ errorMsg, isOpen }) => {
  return (
    <OnboardingDialog open={isOpen} closeIcon header='An Error Occurred'>
      <Typography variant='body1' color='error'>
        {errorMsg}
      </Typography>
    </OnboardingDialog>
  );
};

interface OnboardingErrorProps {
  errorMsg: string;
  isOpen: boolean;
}
